import { useLanguage } from 'context/AppContext';
import Dialog from 'components/Dialog';
import { useDelivery } from 'api/hooks/useDelivery';
import { formatDate } from 'components/DatePicker/DateInput';
import { useMemo } from 'react';

type Props = {
  destinationDeliveryId: string | number | null;
  setNames: string[];
  hasImplants: boolean;
  onCancel: () => void;
};

export const TurnaroundDestinationEntitiesAlreadyPresentDialog = ({
  destinationDeliveryId,
  setNames,
  hasImplants,
  onCancel,
  ...props
}: Props) => {
  const lang = useLanguage()[0].TurnaroundDestinationEntitiesAlreadyPresentDialog;

  const { data: destinationDelivery, isLoading: destinationDeliveryLoading } = useDelivery(destinationDeliveryId);

  const entityNames = useMemo(() => {
    const entityNames = [...setNames];

    // If implants were turned around, instead of showing their names, group them under 'Sterile Implants'
    if (hasImplants) {
      entityNames.push(lang.sterileImplants);
    }

    return entityNames;
  }, [setNames, hasImplants, lang.sterileImplants]);

  return (
    <Dialog
      open
      title={lang.title({
        entityNames,
        surgeryId: destinationDelivery?.surgery?.surgeryReference || '',
        surgeon: destinationDelivery?.surgery?.surgeonName || '',
        surgeryDate: destinationDelivery?.surgery?.surgeryDate
          ? formatDate(destinationDelivery?.surgery?.surgeryDate)
          : '',
      })}
      cancelLabel={lang.cancel}
      cancelDisabled={destinationDeliveryLoading}
      onCancel={onCancel}
      {...props}
    />
  );
};
